//货主船运需求

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 包海事枚举
 */
class PackageCustom extends UltMeta {
    PACK = new Meta(1, "包");
    NO_PACK = new Meta(0, "不包");
}

export const PACKAGE_CUSTOM = new PackageCustom();

/**
 * 货物随船枚举
 */
class TonnageAccompanyingShip extends UltMeta {
    ACCOMPANYING = new Meta(1, "随");
    NO_ACCOMPANYING = new Meta(0, "不随");
}

export const TONNAGE_ACCOMPANYING_SHIP = new TonnageAccompanyingShip();

/**
 * 平台状态枚举
 */
class PlatformState extends UltMeta {
    TO_BE_ASSIGNED = new Meta(1, "待指派");
    PENDING_PROCESSING = new Meta(2, "待处理");
    PROCESSING = new Meta(3, "处理中");
    OWNER_TO_BE_CONFIRMED = new Meta(4, "待货主确认");
    OWNER_CONFIRMED = new Meta(5, "已确认");
    /**
     * 已匹配-关联船运单未完成
     */
    COMPLETED = new Meta(6, "已完成");
    /**
     * 已匹配-关联船运单已完成
     */
    FINISHED = new Meta(7, "已完成");
}

export const PLATFORM_STATE = new PlatformState();

/**
 * 货主状态枚举
 */
class OwnerState extends UltMeta {
    TO_BE_ASSIGNED = new Meta(1, "处理中");
    PENDING_PROCESSING = new Meta(2, "处理中");
    PROCESSING = new Meta(3, "处理中");
    TO_BE_CONFIRMED = new Meta(4, "待确认");
    FIND_THE_SHIP = new Meta(5, "找船中");
    /**
     * 已匹配-关联船运单未完成
     */
    COMPLETED = new Meta(6, "已匹配");
    /**
     * 已匹配-关联船运单已完成
     */
    FINISHED = new Meta(7, "已匹配");
}

export const OWNER_STATE = new OwnerState();

/**
 * 船运定金支付方式
 */
class DepositPaymentMethod extends UltMeta {
    PAY_ONESELF = new Meta(1, "自行支付");
    PAY_ZH = new Meta(2, "服务商垫付");
}

export const DEPOSIT_PAYMENT_METHOD = new DepositPaymentMethod();

/**
 * 船型
 */
class ShipType extends UltMeta {
    BULK_CARGO_SHIP = new Meta(1, "散货船");
    SLUGGING_VESSEL = new Meta(2, "直冲船");
    CHUAN_JIANG_SHIP = new Meta(3, "川江船");
    SELF_UNLOADING_BARGE = new Meta(4, "自卸驳");
    SEAGOING_VESSEL = new Meta(5, "海轮");
}

export const SHIP_TYPE = new ShipType();

/**
 * 海事费用
 */
class MaritimeAffairsFee extends UltMeta {
    SHIPPERS_BEAR_UPSTREAM = new Meta(1, "货主承担上游");
    SHIPPERS_BEAR_DOWNSTREAM = new Meta(2, "货主承担下游");
    SHIPPERS_BEAR_BOTH_PORTS = new Meta(3, "货主承担两港");
    SHIPPERS_NOT_RESPONSIBLE = new Meta(4, "货主不承担");
}

export const MARITIME_AFFAIRS_FEE = new MaritimeAffairsFee();

/**
 * 保存方式枚举
 */
class HasSubmit extends UltMeta {
    SAVE_ONLY = new Meta(1, "仅保存");
    SAVE_AND_SUBMIT = new Meta(2, "保存并提交");
}

export const HAS_SUBMIT = new HasSubmit();

/**
 * 状态整合（货主船运需求状态和船运单状态） 主要状态查询
 */
class TransportOrderState extends UltMeta {
    /**
     * (自行支付)
     */
    DEPOSIT_CONFIRMING_PAY_ONESELF = new Meta(1, "定金确认中");
    SHIP_INFO_FEE_TO_BE_PAID = new Meta(2, "待付信息服务费");
    AWAITING_DEPARTURE = new Meta(3, "待发航");
    TO_BE_UNLOADED = new Meta(4, "待卸货");
    TO_BE_CONFIRMED = new Meta(5, "待确认");
    PENDING_PROCESSING = new Meta(6, "处理中");
    FIND_THE_SHIP = new Meta(7, "找船中");
    /**
     * (服务商支付)
     */
    DEPOSIT_CONFIRMING_PAY_ZH = new Meta(8, "定金确认中");
    SHIP_INFO_FEE_CONFIRMING = new Meta(9, "信息服务费确认中");
    DURING_LOADING = new Meta(10, "装货中");
    DURING_TRANSPORTATION = new Meta(11, "运输中");
    DURING_UNLOADING = new Meta(12, "卸货中");
    COMPLETED = new Meta(13, "已完成");
    UNCOMPLETED = new Meta(14, "未完成");
}

export const TRANSPORT_ORDER_STATE = new TransportOrderState();
